/**
 * Mode lecture, colonne latérale : informations et mots-clés de l'exercice.
 */

import React from 'react';
import { Box, Typography, Card, CardContent, Divider, Chip } from '@mui/material';
import { getDifficultyColor, getDifficultyLabel } from './difficulty';
import { ExerciseFormData } from './types';

interface ReadProps {
  formData: ExerciseFormData;
}

/** Carte Informations : difficulté, points, statut, nombre d'indices. */
const ExerciseInfoCard: React.FC<ReadProps> = ({ formData }) => (
  <Card elevation={2} sx={{ mb: 3 }}>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        Informations
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Box mb={2}>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Difficulté
        </Typography>
        <Chip
          label={getDifficultyLabel(formData.difficulty || 'medium')}
          color={getDifficultyColor(formData.difficulty || 'medium')}
          size="small"
        />
      </Box>

      <Box mb={2}>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Points
        </Typography>
        <Typography variant="h4" color="primary">
          {formData.points || 0}
        </Typography>
      </Box>

      <Box mb={2}>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Statut
        </Typography>
        <Chip
          label={formData.status === 'published' ? 'Publié' : 'Brouillon'}
          color={formData.status === 'published' ? 'success' : 'default'}
          size="small"
        />
      </Box>

      <Box>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Nombre d'indices
        </Typography>
        <Typography variant="body1">
          {formData.hints?.length || 0}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);

/** Colonne latérale du mode lecture. */
export const ExerciseReadSidebar: React.FC<ReadProps> = ({ formData }) => (
  <>
    {/* Exercise Info */}
    <ExerciseInfoCard formData={formData} />

    {/* Keywords */}
    {formData.keywords && formData.keywords.length > 0 && (
      <Card elevation={2}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Mots-clés
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Box display="flex" flexWrap="wrap" gap={1}>
            {formData.keywords.map((keyword, index) => (
              <Chip
                key={index}
                label={keyword}
                size="small"
                color="secondary"
                variant="outlined"
              />
            ))}
          </Box>
        </CardContent>
      </Card>
    )}
  </>
);
